import React, { useState, useEffect, useRef } from "react";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SaveIcon from "@material-ui/icons/Save";
import CloseIcon from "@material-ui/icons/Close";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Moment from "moment";
import BiztranControls from "../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../hooks/UseFetchData";
import Global from "../../Global";
import Modal_Frame from "../biztran_controls/Modal_Frame";
import { Group } from "@material-ui/icons";


const CreateModelMaster = (props) => {

  //const classes = useStyles();
  const [Mode, setMode] = useState("");
  const [ModelID, setModelID] = useState('');
  const [ModelCode, setModelCode] = useState('');
  const [ModelName, setModelName] = useState('');
  const [UserManual, setUserManual] = useState('');
  const [UserManualUploaded, setUserManualUploaded] = useState(false);
  const [WarrentyUploaded, setWarrentyUploaded] = useState(false);
  const [KitUploaded, setKitUploaded] = useState(false);
  const [UnpackingUploaded, setUnpackingUploaded] = useState(false);
  const [WarrantyRegForm, setWarrantyRegForm] = useState(false);
  const [UnpackingManual, setUnpackingManual] = useState(false);
  const [pdfFile, setPdfFile] = useState(null);
  const [pdfFileError, setPdfFileError] = useState('');
  const [MainState, setMainState] = useState('initial');
  const [SelectedPdf, setSelectedpdf] = useState(null);
  const [PdfUploaded, setPdfUploaded] = useState(0);
  const [response, fetchData1] = UseFetchData();
  const [KitAssemblyInstructions, setKitAssemblyInstructions] = useState('');
  const [CreatedByID, setCreatedByID] = useState(sessionStorage.UserName);
  const [CreatedOn, setCreatedOn] = useState(Moment(new Date()).format("YYYY-MM-DD"));
  const [ModifiedByID, setModifiedByID] = useState(sessionStorage.UserName);
  const [ModifiedOn, setModifiedOn] = useState(Moment(new Date()).format("YYYY-MM-DD"));
  const [responseUpload, UploadData] = UseFetchData();
  const [responseGetData, fetchGetData] = UseFetchData();
  //  const { value, onChange, ...rest } = props;
  const [cursor, setCursor] = useState(null);
  const ref = useRef(null);



  const validationSchema = Yup.object({
    ModelCode: Yup.string().required("Required!"),
    ModelName: Yup.string().required("Required!"),
    // ContactName: Yup.string().required("Required!"),

  });

  //   useEffect(() => {
  //     const input = ref.current;
  //     if (input) input.setSelectionRange(cursor, cursor);
  // }, [ref, cursor, value]);

  const onSubmit = values => {
    var bodyFormData = new FormData();
    var FilePathUserManual, FilePathUserWarrantyRegForm, FilePathKitAssemblyInstructions, FilePathUnpacking;
    if (UserManualUploaded === true) {
      FilePathUserManual = Global.BASE_URL + ModelCode + "UM.pdf";
    } else {
      var FilePathUserManual = "";
    }
    if (WarrentyUploaded === true) {
      FilePathUserWarrantyRegForm = Global.BASE_URL + ModelCode + "WRF.pdf";
    } else {
      FilePathUserWarrantyRegForm = "";
    }
    if (KitUploaded === true) {
      FilePathKitAssemblyInstructions = Global.BASE_URL + ModelCode + "KAI.pdf";
    } else {
      FilePathKitAssemblyInstructions = "";
    }
    if (UnpackingUploaded === true) {
      FilePathUnpacking = Global.BASE_URL + ModelCode + "UPM.pdf";
    } else {
      FilePathUnpacking = "";
    }
    debugger;
    bodyFormData.append("ModelID", props.ModelID);
    bodyFormData.append("ModelCode", ModelCode);
    bodyFormData.append("ModelName", ModelName);
    bodyFormData.append("UserManual", FilePathUserManual);
    bodyFormData.append("WarrantyRegForm", FilePathUserWarrantyRegForm);
    bodyFormData.append("KitAssemblyInstructions", FilePathKitAssemblyInstructions);
    bodyFormData.append("UnpackingManual", FilePathUnpacking);
    fetchData1("Model/Save", bodyFormData);
  }

  const onUploadFile = (FName, FileExtension, Base64, Type, SubType) => {
    debugger;
    var bodyFormData = new FormData();
    bodyFormData.append("Type", Type);
    bodyFormData.append("SubType", SubType);
    bodyFormData.append("FileName", FName);
    bodyFormData.append("ModelID", props.ModelID);
    bodyFormData.append("ModelCode", ModelCode);
    bodyFormData.append("ModelName", ModelName);
    //bodyFormData.append("Type", "PDF");
    //bodyFormData.append("Group", "Model");
    bodyFormData.append("UserManual", UserManual);
    bodyFormData.append("WarrantyRegForm", WarrantyRegForm);
    bodyFormData.append("KitAssemblyInstructions", KitAssemblyInstructions);
    bodyFormData.append("UnpackingManual", UnpackingManual);
    bodyFormData.append("FileExtension", FileExtension);
    bodyFormData.append("FileString", Base64[0].split(',')[1]);
    UploadData("Model/Attachment", bodyFormData);
  }

  const handleUploadClick = (event) => {
    try {
      debugger;
      var Type, SubType;
      console.log(event.target.name);
      if (event.target.name === "UM") {
        Type = "UM";
        SubType = "UserManual";
        setUserManualUploaded(true);
      } else if (event.target.name === "WRF") {
        Type = "WRF";
        SubType = "WarrantyRegForm";
        setWarrentyUploaded(true);
      } else if (event.target.name === "KAI") {
        Type = "KAI";
        SubType = "KitAssemblyInst";
        setKitUploaded(true);
      } else if (event.target.name === "UPM") {
        Type = "UPM";
        SubType = "UnpackingManual";
        setUnpackingUploaded(true);
      }
      var file = event.target.files[0];
      var FName = file.name;
      var FileExtension = file.name.split('.')[1];
      var Base64 = null;
      const reader = new FileReader();
      var url = reader.readAsDataURL(file);
      reader.onloadend = function (e) {
        setSelectedpdf([reader.result]);
        Base64 = [reader.result];
        setMainState("uploaded")
        if (MainState === "uploaded") {
          setPdfUploaded(1);
          setSelectedpdf(event.target.files[0])
        }
        onUploadFile(FName, FileExtension, Base64, Type, SubType);
      };
    }
    catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (responseUpload.Response === true) {
      //props.setOpen(false);
      //props.PopulateData();
      //alert('Saved Succesfully.')
    }
    else if (responseUpload.Response === false) {
      alert('Save Failed.')
    }
  }, [responseUpload])

  const getByIDData = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("ModelID", props.ModelID);
    fetchGetData("Model/GetByID", bodyFormData);
  }

  useEffect(() => {
    debugger;
    if (response.Response === true) {
      alert('Data Saved Succesfully.');
      props.PopulateData();
      props.setOpen(false);
    }
    else if (response.Response === false) {
      if (response.Message.includes('Already') === true) {
        alert(response.Message);
      }
      else {
        alert('Failed.');
      }
    }
    if (response.length > 0 && Mode === 'Update') {
      setModelCode(response[0].ModelCode);
      setModelName(response[0].ModelName);
      setUserManual(response[0].UserManual);
      setKitAssemblyInstructions(response[0].WarrantyRegForm);
      setWarrantyRegForm(response[0].KitAssemblyInstructions);
      // setMfgDate((response[0].MfgDate === null) ? "" : Moment(response[0].MfgDate).format('YYYY-MM-DD'));
      setModelID((response[0].ModelID === null) ? "" : response[0].ModelID);

    }
  }, [response]);

  // const fileType = ['application/pdf'];
  // const handlePdfFileChange = (e) => {
  //   let selectedFile = e.target.files[0];
  //   if(selectedFile) {
  //     if(selectedFile && fileType.includes(selectedFile.type)) {
  //       let reader = new FileReader();
  //       reader.readAsDataURL(selectedFile);
  //       reader.onloadend = (e) => {
  //         setPdfFile(e.target.result);
  //         setPdfFileError('');
  //       }
  //     }
  //     else {
  //       setPdfFile(null);
  //       setPdfFileError('Please select valid pdf file');
  //     }
  //   }
  //   else {
  //     console.log('select your file');
  //   }
  // }

  useEffect(() => {
    if (responseGetData.length > 0) {
      setModelID(responseGetData[0].ModelID);
      setModelCode(responseGetData[0].ModelCode);
      setModelName(responseGetData[0].ModelName);

    }
  }, [responseGetData]);


  useEffect(() => {
    getByIDData();
  }, [])


  return (<div>
    <Formik initialValues={{
      ModelID: ModelID,
      ModelCode: ModelCode, ModelName: ModelName, UserManual: UserManual, WarrantyRegForm: WarrantyRegForm,
      KitAssemblyInstructions: KitAssemblyInstructions, CreatedByID: CreatedByID, CreatedOn: CreatedOn,
      ModifiedByID: ModifiedByID, ModifiedOn: ModifiedOn
    }}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      onUploadFile={onUploadFile}
      enableReinitialize>
      {formik => {
        return <Form>
          <Grid item xs={12} spacing={1} container direction="row">
            <Grid item xs={12} spacing={1} container rowSpacing={2} direction="row" >
              <Grid item xs={2}>
                <label
                  htmlFor={"ModelCode"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"Model Number"}
                </label>
              </Grid>
              <Grid item xs={10} >
                <BiztranControlsFormik
                  autoFocus="autofocus"
                  control="input"
                  type="text"
                  name="ModelCode"
                  //ref={ref}
                  value={ModelCode}
                  //options={ASIcmb}                   
                  onChange={(e) => {
                    setModelCode(e.target.value)
                    //handleChange()
                  }}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} spacing={1} container rowSpacing={2} direction="row" >
              <Grid item xs={2}>
                <label
                  htmlFor={"ModelName"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"Model Name"}
                </label>
              </Grid>
              <Grid item xs={10} >
                <BiztranControlsFormik
                  autoFocus="autofocus"
                  control="input"
                  type="text"
                  name="ModelName"
                  //ref={ref}
                  value={ModelName}
                  //options={ASIcmb}                   
                  onChange={(e) => {
                    setModelName(e.target.value)
                    //handleChange()
                  }}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} spacing={1} container rowSpacing={2} direction="row" >
              <Grid item xs={2}>
                <label
                  htmlFor={"UserManual"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"Upload User Manual"}
                </label>
              </Grid>
              <Grid item xs={10} >
                <div>
                  <input type='file' style={{ marginTop: 5, marginLeft: 5, height: "20%", width: "30%" }} accept="pdf/*"
                    onChange={handleUploadClick}
                    name="UM"
                  // className={classes.input}
                  //id={ props.id }   multiple   
                  />
                </div>
              </Grid>
            </Grid>
            {/* <Grid item xs={12} spacing={1} container rowSpacing={2} direction="row" >
              <Grid item xs={2}>
                <label
                  htmlFor={"WarrantyRegForm"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"Upload Warrenty Reg Form"}
                </label>
              </Grid>
              <Grid item xs={10} >
                <div >
                  <input type='file' style={{ marginTop: 5, marginLeft: 5, height: "20%", width: "30%" }} accept="pdf/*"
                    onChange={handleUploadClick}
                    name="WRF"
                  />
                </div>
              </Grid>
            </Grid> */}
            <Grid item xs={12} spacing={1} container rowSpacing={2} direction="row" >
              <Grid item xs={2}>
                <label
                  htmlFor={"KitAssemblyInstructions"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"Upload Kit Assembly Instructions"}
                </label>
              </Grid>
              <Grid item xs={10} >
                <div>
                  <input type='file' style={{ marginTop: 5, marginLeft: 5, height: "20%", width: "30%" }} accept="pdf/*"
                    onChange={handleUploadClick}
                    name="KAI"
                  />
                </div>
              </Grid>
            </Grid>
            <Grid item xs={12} spacing={1} container rowSpacing={2} direction="row" >
              <Grid item xs={2}>
                <label
                  htmlFor={"UnpackingManual"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"Upload Unpacking Manual"}
                </label>
              </Grid>
              <Grid item xs={10} >
                <div>
                  <input type='file' style={{ marginTop: 5, marginLeft: 5, height: "20%", width: "30%" }} accept="pdf/*"
                    onChange={handleUploadClick}
                    name="UPM"
                  />
                </div>
              </Grid>
            </Grid>

            <Grid item xs={12} spacing={1} container direction="row">
              <Grid item xs={2}>
                <label
                  htmlFor={"CreatedByID"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"Created By"}
                </label>
              </Grid>
              <Grid item xs={4} >
                <BiztranControlsFormik
                  autoFocus="autofocus"
                  control="input"
                  type="text"
                  name="CreatedByID"
                  //ref={ref}
                  value={CreatedByID}
                  disabled={true}
                  //options={ASIcmb}                   
                  onChange={(e) => {
                    setCreatedByID(e.target.value)
                    //handleChange()
                  }}
                />
              </Grid>
              <Grid item xs={2}>
                <label
                  htmlFor={"CreatedOn"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"Created On "}
                </label>
              </Grid>
              <Grid item xs={4} >
                <BiztranControlsFormik
                  autoFocus="autofocus"
                  control="input"
                  type="text"
                  name="Created On"
                  //ref={ref}
                  value={CreatedOn}
                  // options={Branchcmb}
                  disabled={true}
                  onChange={(e) => {
                    setCreatedOn(e.target.value)
                    //handleChange()
                  }}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} spacing={1} container direction="row">
              <Grid item xs={2}>
                <label
                  htmlFor={"ModifiedByID"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"Modified By"}
                </label>
              </Grid>
              <Grid item xs={4} >
                <BiztranControlsFormik
                  autoFocus="autofocus"
                  control="input"
                  type="text"
                  name="ModifiedByID"
                  //ref={ref}
                  value={ModifiedByID}
                  disabled={true}
                  // options={RMcmb}                   
                  onChange={(e) => {
                    setModifiedByID(e.target.value)
                    //handleChange()
                  }}
                />
              </Grid>
              <Grid item xs={2}>
                <label
                  htmlFor={"ModifiedOn"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"Modified On "}
                </label>
              </Grid>
              <Grid item xs={4} >
                <BiztranControlsFormik
                  autoFocus="autofocus"
                  control="input"
                  type="text"
                  name="ModifiedOn"
                  //ref={ref}
                  value={ModifiedOn}
                  // options={Branchcmb}
                  disabled={true}
                  onChange={(e) => {
                    setModifiedOn(e.target.value)
                    //handleChange()
                  }}
                />
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <div style={{ width: '100%' }}>
                <div style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>
                  <BiztranControls.Button
                    text="SAVE"
                    type="submit"
                    startIcon={<SaveIcon />}
                  />
                  <BiztranControls.Button
                    text="CLOSE"
                    startIcon={<CloseIcon />}
                    onClick={() => { props.setOpen(false); }}
                  />
                </div>
              </div>
            </Grid>
          </Grid>
        </Form>
      }}
    </Formik>

  </div>)

}

export default CreateModelMaster;